import { Link } from "react-router-dom";

export function CompanySequencesTab() {
  return (
    <div className="rounded-lg border border-dashed border-border px-4 py-12 text-center">
      <p className="text-sm font-medium">No account sequences</p>
      <p className="mt-1 text-xs text-muted-foreground">
        Sequence enrollments for people at this company will appear here.
      </p>
      <Link
        to="/sequences"
        className="mt-3 inline-block text-sm text-brand hover:underline"
      >
        Browse sequences
      </Link>
    </div>
  );
}

export function CompanyConversationsTab() {
  return (
    <div className="rounded-lg border border-dashed border-border px-4 py-12 text-center">
      <p className="text-sm font-medium">No conversations yet</p>
      <p className="mt-1 text-xs text-muted-foreground">
        Email and call threads linked to this account will appear here.
      </p>
      <Link
        to="/conversations"
        className="mt-3 inline-block text-sm text-brand hover:underline"
      >
        Open conversations hub
      </Link>
    </div>
  );
}
